import useTranslation from '../useTranslation';
import type { BatteryResponse } from 'generatedTypes/asset/models';
import { parseToItems } from 'utils/parseToItems';

import useBatteries from 'hooks/useBatteries';
import useSelectPanelField from 'hooks/useSelectPanelField';

import { DEFAULT_PAGE_SIZE } from './constants';

const useData = () => {
    const { fetch, isLoading, reset } = useBatteries();
    const { NO_BATTERIES_FOUND } = useTranslation();

    const { handleAsyncFilter, hasNextPage, items, noItemsText, onNextPage } =
        useSelectPanelField<BatteryResponse>({
            fetchFn: fetch,
            noItemsFoundText: NO_BATTERIES_FOUND,
            pageSize: DEFAULT_PAGE_SIZE,
            parseFn: parseToItems,
            resetFn: reset
        });

    return {
        batteryItems: items,
        handleAsyncFilter,
        hasNextPage,
        isLoading,
        noItemsText,
        onNextPage
    };
};

export default useData;
